import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Services', href: '/services' },
  { label: 'About Us', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  return (
    <>
      {/* Utility bar */}
      <div className="hidden md:block bg-[#080808] border-b border-white/5">
        <div className="max-w-7xl mx-auto px-8 h-9 flex items-center justify-between">
          <div className="flex items-center gap-7">
            <a href="tel:+15127990115" className="flex items-center gap-2 text-white/55 hover:text-[#C4962A] transition-colors text-xs font-medium tracking-wide cursor-pointer">
              <i className="ri-phone-fill text-[#C4962A] text-xs" />
              (512) 799-0115
            </a>
            <a href="mailto:chris@capitalareasign.com" className="flex items-center gap-2 text-white/55 hover:text-[#C4962A] transition-colors text-xs font-medium tracking-wide cursor-pointer">
              <i className="ri-mail-line text-[#C4962A] text-xs" />
              chris@capitalareasign.com
            </a>
            <span className="flex items-center gap-2 text-white/35 text-xs">
              <i className="ri-map-pin-2-fill text-[#C4962A] text-xs" />
              Austin, Texas — Serving Central TX
            </span>
          </div>
          <div className="flex items-center gap-4">
            {[
              { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/capitalareasigns' },
              { icon: 'ri-twitter-x-fill', href: 'https://x.com/capitalsigns' },
              { icon: 'ri-whatsapp-fill', href: 'https://wa.me/15127990115' },
            ].map((s) => (
              <a key={s.href} href={s.href} target="_blank" rel="nofollow noopener"
                className="w-5 h-5 flex items-center justify-center text-white/35 hover:text-[#C4962A] transition-colors cursor-pointer">
                <i className={`${s.icon} text-xs`} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav className={`w-full fixed left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'top-0 bg-[#0C0C0C]/98 backdrop-blur-md border-b border-white/8'
          : 'top-0 md:top-9 bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-8 h-[76px] flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 group">
            <img
              src="https://capitalareasigns.com/wp-content/uploads/2026/01/Capital-Area-Signs-Logo-164PX.png"
              alt="Capital Area Signs — Custom Signs Austin TX"
              className="h-12 w-auto object-contain transition-all duration-300"
              style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.6))' }}
            />
          </Link>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href}
                className={`text-sm font-semibold tracking-widest uppercase transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? 'text-[#C4962A]'
                    : scrolled ? 'text-white/70 hover:text-white' : 'text-white/75 hover:text-white'
                }`}>
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-4">
            <a href="tel:+15127990115"
              className="text-white/60 hover:text-white transition-colors text-sm font-semibold whitespace-nowrap cursor-pointer flex items-center gap-2">
              <i className="ri-phone-fill text-[#C4962A]" />
              (512) 799-0115
            </a>
            <a href="#quote" className="btn-gold cursor-pointer">
              Get a Quote
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer">
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
          </button>
        </div>

        {/* Mobile dropdown */}
        {mobileOpen && (
          <div className="md:hidden bg-[#0C0C0C] border-t border-white/8 px-8 pb-8 pt-4">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href}
                className="block py-4 text-white/70 font-semibold text-sm uppercase tracking-widest border-b border-white/5 hover:text-[#C4962A] transition-colors cursor-pointer">
                {link.label}
              </Link>
            ))}
            <div className="flex flex-col gap-3 mt-6">
              <a href="tel:+15127990115" className="btn-outline-white cursor-pointer text-center">
                <i className="ri-phone-fill" /> (512) 799-0115
              </a>
              <a href="#quote" className="btn-gold cursor-pointer text-center">
                Get a Free Quote
              </a>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}
